<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-header">
        <h3>Choose an Exempt Vendor Type</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body">
        <select class="form-select" [(ngModel)]="exemptVendorTypeId">
          <option [ngValue]="null" disabled selected>Pick one...</option>
          @for (item of ExemptVendorTypes; track item) {
            <option [ngValue]="item.id">
              {{ item.type }}
            </option>
          }
        </select>
      </div>
      <div class="modal-footer">
        <div class="row w-100 justify-content-end">
          <div class="col-3">
            <button type="button" class="btn btn-danger" (click)="closeModal()">
              Cancel
            </button>
          </div>
          <div class="col-3">
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="!exemptVendorTypeId"
              (click)="submit()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
